import { createStore, compose } from 'redux';
import { combineReducers } from 'redux';
import { fxData, pageSize, searchTerm } from './data/data';

const rootReducer = combineReducers({
    fxData,
    pageSize,
    searchTerm
});

const store = createStore(
  rootReducer,
  compose(
    // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  )
)

export default store;